module.exports = __webpack_public_path__ + "img/builder-22.3ab0d129.jpg";